import { motion } from "framer-motion";

const Banner = () => {
  return (
    <section className="relative w-full h-[400px] md:h-[500px] flex items-center justify-start overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: "url('/banner.png')" }}
      ></div>

      {/* Content */}
      <div className="max-w-[1280px] mx-auto w-full">
        <div className="relative z-10 md:px-10 px-5 text-white">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="text-sm md:text-base font-medium"
          >
            Innovate. Elevate. Dominate.
          </motion.p>

          <h1 className="text-3xl md:text-5xl font-bold leading-tight mt-2">
            Smart Tech & <span className="text-yellow-400">Reliable</span>  <br />
            Support for Business Success
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            className="mt-7 text-sm md:text-base max-w-xl"
          >
            At Binary Ops Pvt Ltd, we transform visionary ideas into powerful
            digital solutions. From web and app development to custom software,
            UI/UX design, and software testing, we craft technology that drives
            success. Our dedicated customer support ensures seamless operations,
            empowering businesses to scale effortlessly.
          </motion.p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ amount: 0.2 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.4 }}
            className="mt-4 text-sm md:text-base max-w-xl"
          >
            With a strong presence in the UK, Islamabad, and Peshawar, we
            deliver world-class innovation with a local touch—helping businesses
            thrive in an ever-evolving digital landscape.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default Banner;
